export default "__VITE_ASSET__Dvkg5LR7__"